export const galleryTabs = [
  { id: 'all', label: 'Everything' },
  { id: 'toddlers', label: 'Toddler Room' },
  { id: 'classrooms', label: 'Classrooms' },
  { id: 'sport', label: 'Sport' },
  { id: 'events', label: 'Events' },
  { id: 'campus', label: 'Campus' },
];

/* `span: 2` is a landscape tile that takes two columns of the masonry. */
export const galleryItems = [
  { id: 'g-1', category: 'classrooms', caption: 'Primary 3, Tuesday morning maths', span: 2 },
  { id: 'g-2', category: 'toddlers', caption: 'Water table, Toddler garden' },
  { id: 'g-3', category: 'toddlers', caption: 'Story circle before nap' },
  { id: 'g-4', category: 'sport', caption: 'Under-13 football training' },
  { id: 'g-5', category: 'classrooms', caption: 'One-to-one reading with Ms. Grace' },
  { id: 'g-6', category: 'events', caption: 'Sports day, September', span: 2 },
  { id: 'g-7', category: 'classrooms', caption: 'Grade 8 chemistry lab' },
  { id: 'g-8', category: 'events', caption: 'Science fair prototype' },
  { id: 'g-9', category: 'toddlers', caption: 'Harvesting from the vegetable bed' },
  { id: 'g-10', category: 'campus', caption: 'The library, first thing', span: 2 },
  { id: 'g-11', category: 'campus', caption: 'Covered walkway in the rains' },
  { id: 'g-12', category: 'sport', caption: 'Netball court, break time' },
];
